import api from "services/api";
import { getHolidayDateMap } from "common/calendar";

/**
 * Resolves the signed-in employee's own holiday region, then that region's holidays for
 * the given year, as an { [isoDate]: holiday } map.
 *
 * An employee with no region assigned gets an empty map, which matches the backend
 * excluding no public holidays from their leave day calculation.
 */
const getMyHolidays = async (year) => {
	const employeeInfo = await api.get.employee.employeeInfo();

	if (!employeeInfo?.holidayRegionCode) return {};

	const holidays = await api.get.holidayCalendar.yearByRegion(year, employeeInfo.holidayRegionCode);

	return getHolidayDateMap(holidays);
};

export default getMyHolidays;
